

export default function ExpandIcon({ className }) {
    return <svg className={className} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.16667 5.83333L12.25 1.75M12.25 1.75H8.75M12.25 1.75V5.25M5.83333 8.16667L1.75 12.25M1.75 12.25H5.25M1.75 12.25L1.75 8.75" stroke="#212121" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

}